<svg
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.7815 11.7376L7.4778 6.50008L12.7815 1.26259C13.0492 0.998264 13.0739 0.541826 12.8361 0.24283C12.5982 -0.0561667 12.1874 -0.0821668 11.9183 0.182163L6.50026 5.53376L1.0822 0.182163C0.81442 -0.0821668 0.403646 -0.0561667 0.164461 0.24283C-0.0747243 0.541826 -0.0500255 0.99682 0.219058 1.26259L5.52272 6.50008L0.219058 11.7376C-0.0487255 12.0019 -0.0734244 12.4583 0.164461 12.7573C0.293153 12.9177 0.471241 13 0.65063 13C0.80402 13 0.95871 12.9393 1.0822 12.818L6.50026 7.4664L11.9183 12.818C12.0418 12.9408 12.1965 13 12.3499 13C12.5293 13 12.7074 12.9177 12.8361 12.7573C13.0739 12.4598 13.0505 12.0033 12.7815 11.7376Z"
    fill="currentColor"
  />
</svg>
